import { useCallback, useMemo } from 'react';
import { useRxData } from 'rxdb-hooks';

import { EL, MI, SH, ST } from '../../utilities/constants';
import { Discipline } from '../../utilities/enums';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type { Urgency, UrgencyCollection } from './urgency.types';

const useUrgency = (disciplineId: number) => {
  const validOptions = useMemo(() => {
    if (disciplineId === Discipline.Structural) return ST.urgency;
    if (disciplineId === Discipline.Mechanical) return MI.urgency;
    if (disciplineId === Discipline.Shaft) return SH.urgency;
    if (disciplineId === Discipline.Electrical) return EL.urgency;
    return [];
  }, [disciplineId]);

  const getUrgencyQuery = useCallback(
    (collection: UrgencyCollection) => {
      return collection?.find({ selector: { sort: { $in: validOptions } } });
    },
    [validOptions],
  );

  const { result: urgencyListData } = useRxData<Urgency>(
    RxdbCollectionName.URGENCY,
    getUrgencyQuery,
    { json: true },
  );

  return { urgencyListData };
};

export default useUrgency;
